import { useRef, useState } from 'react';

import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { ContainerStatistics } from '../components/ContainerStatistics';
import { FormSearchStatistics } from '../components/FormSearchStatistics';
import { type StatisticsRequest } from '../types';

export const Statistics = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const formRef = useRef<any>(null);
  const [search, setSearch] = useState<StatisticsRequest>({});

  const onSubmit = (values: any) => {
    setSearch({ ...values, taxId: values?.tax?.id });
  };

  return (
    <>
      <PageTitle title={t('roles.collection_statistics')} />

      <h2>{t('common.label.filters')}</h2>
      <FormSearchStatistics nameForm="formStatistics" onSubmit={onSubmit}>
        {(reset: any) => {
          return (
            <>
              <BtnToolbar>
                <BtnGroup>
                  <Button
                    action={ButtonAction.clean}
                    onClick={() => {
                      reset({
                        tax: null
                      });
                      setSearch({});
                    }}
                  />
                </BtnGroup>
                <BtnGroup>
                  <Button action={ButtonAction.find} variant="primary" type={'submit'} />
                </BtnGroup>
              </BtnToolbar>
            </>
          );
        }}
      </FormSearchStatistics>
      <section className="mt-4">
        <h2>{t('collections.title.StatisticQueryResult')}</h2>
        <ContainerStatistics search={search} />
      </section>
    </>
  );
};
